import { ParsedBuyerImportRow } from '@/services/projects';
import { validateEmail, validatePhone } from '@/utils/string';

// export enum BuyerImportRowStatus {
//     Ready,
//     AlreadyExists,
//     InvalidUnit,
//     Failed,
//     Queued,
//     Sending,
//     Sent,
// }

export enum BuyerImportRowSendStatus {
    Ready,
    Failed,
    Queued,
    Sending,
    Sent,
}

export function validateRow(row: BuyerMassImportRow | ParsedBuyerImportRow) {
    return {
        emailValid: validateEmail(row.email),
        phoneValid: (!row.phoneNumber && !row.inviteSms) || validatePhone(row.phoneNumber),
    };
}

export type BuyerMassImportRowValidations = ReturnType<typeof validateRow>;
export type BuyerMassImportRow = ParsedBuyerImportRow & {
    sendStatus: BuyerImportRowSendStatus;
    // validationErrors: string[];
    rowId: string;
    validation: BuyerMassImportRowValidations;
    shouldInvite: boolean;
};

export { default } from './BuyerMassInvite';